<template>
  <div></div>
</template>

<script setup>
import { _getStorageWithExpiry, _safeAtob } from '../utils/common.js';
import { onMounted, ref } from 'vue';
import api from '@/utils/api.js';
import { useRoute, useRouter } from 'vue-router';
import { gaEvent } from '@/utils/ga.js';

const route = useRoute();
const router = useRouter();

const success = ref(false);
const impUid = ref('');

onMounted(async () => {
  success.value = route.query.imp_success === 'true';
  impUid.value = route.query.imp_uid ?? '';

  if (!success.value) {
    alert('결제에 실패하였습니다. 관리자에게 문의해주세요');
    gaEvent('purchase_fail', {
      product_id: route.query.productId,
      reason: 'fail',
    });
    //http://localhost:8080/payResult?s_id=null&id=nid_202915677&productId=9UIF3l3&imp_uid=imp_764369184113&merchant_uid=order_id_1766044365483&imp_success=false&error_msg=%EC%82%AC%EC%9A%A9%EC%9E%90%EA%B0%80+%EA%B2%B0%EC%A0%9C%EB%A5%BC+%EC%B7%A8%EC%86%8C%ED%95%98%EC%85%A8%EC%8A%B5%EB%8B%88%EB%8B%A4
    const fallbackPath = route.query.productId ? `/productDetail/${route.query.productId}` : '/';
    router.replace(fallbackPath);
    return;
  }

  try {
    const storedSId = route.query.s_id ?? '';
    const idntCode = _safeAtob(_getStorageWithExpiry('id'));

    const order_id = route.query.orderId;

    await api.post('/order.php', {
      mode: 'marketUpdate',
      storedId: storedSId,
      imp_uid: impUid.value,
      order_id: order_id,
      idnt_code: idntCode,
    });

    gaEvent('begin_checkout', {
      page_name: 'payment',
      product_id: route.query.productId,
      product_name: route.query.productName,
      order_id: order_id,
    });

    router.replace({
      path: '/orderComplete',
      state: {
        orderId: order_id,
      },
    });
  } catch (err) {
    console.error('결제 후처리 실패', err);
    gaEvent('purchase_fail', {
      product_id: route.query.productId,
      product_name: route.query.productName,
      reason: 'fail',
    });
    alert('결제 처리 중 오류가 발생했습니다. 관리자에게 문의 바랍니다.');
  }
});
</script>
